import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules  } from '@angular/router'; 
import { PagesComponent } from './pages/pages.component';
import { BlankComponent } from './pages/blank/blank.component';
import { SearchComponent } from './pages/search/search.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';

export const routes: Routes = [
  { path: 'views', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) },
  { path:'',loadChildren:()=>import('./accounts/accounts.module').then(m=>m.AccountsModule) },
  // {
  //   path: '', 
  //   component: PagesComponent, 
  //   children:[
  //     { path: '', loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule) },          
  //     { path: 'blank', component: BlankComponent, data: { breadcrumb: 'Blank page' } },
  //     { path: 'search', component: SearchComponent, data: { breadcrumb: 'Search' } }
  //   ]
  // },

  { path: '**', component: NotFoundComponent }
]; 

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
       // <- comment this line for activate lazy load
      useHash: true
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }